import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";

Fancybox.bind("[data-fancybox]", {
  // Your custom options
});
